const messages = {
  pt: {
    translations: {
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Entrar",
          register: "Não tem um conta? Cadastre-se!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets hoje: ",
          },
        },
        metrics: {
          filterDate: "Filtrar por dia",
          sales: {
            title: "Vendas",
            subtitle: "{{count}} purchase(s) enviado(s) ao pixel",
          },
          clicks: {
            title: "Cliques no link",
            subtitle: "Acessos ao contador no dia selecionado",
          },
          conversations: {
            title: "Conversas iniciadas",
            subtitle: "Contatos identificados no Whaticket no dia",
          },
        },
        messages: {
          inAttendance: {
            title: "Em Atendimento"
          },
          waiting: {
            title: "Aguardando"
          },
          closed: {
            title: "Finalizado"
          }
        }
      },
      connections: {
        title: "Conexões",
        toasts: {
          deleted: "Conexão com o WhatsApp excluída com sucesso!",
          whatsappIdCopied: "WhatsApp ID copiado! Cole no MacroDroid (campo whatsappId).",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar WhatsApp",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          hybridConnected: {
            content:
              "Web ativo: recebe mensagens e envia mídia. Vincule o USB para envio de texto pelo celular.",
          },
          webOnlyConnected: {
            content:
              "Modo somente Web: recebe e envia tudo pela sessão Web (ideal para iPhone).",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
          waitingAgent: {
            title: "Aguardando agente Android",
            content:
              "Inicie o android-bridge-agent no PC e conecte o celular via USB.",
          },
          deviceConnected: {
            title: "Dispositivo Android conectado",
            content: "Sessão ativa via bridge USB.",
          },
          deviceOffline: {
            title: "Dispositivo offline",
            content:
              "O agente local perdeu conexão. Verifique USB, adb e se o agente está rodando.",
          },
        },
        table: {
          name: "Nome",
          whatsappId: "WhatsApp ID",
          whatsappIdHint:
            "Clique no ID para copiar. Use no JSON do MacroDroid: \"whatsappId\": NÚMERO",
          copyWhatsappId: "Copiar WhatsApp ID",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
          connectionMode: "Modo",
          phone: "Número",
          counterPhone: "Número contador",
          autoDisableCounter: "Desativação automática",
        },
        autoDisable: {
          active: "Ativa",
        },
        connectionMode: {
          hybrid: "Híbrido",
          web: "Somente Web",
          usb: "USB (depuração)",
        },
        meta: {
          panelTitle: "WhatsApp Oficial (Meta Cloud)",
          panelInstructions:
            "Conecte novos números pelo Cadastro Incorporado da Meta (Embedded Signup). Não usa QR Code Baileys.",
          connectButton: "Conectar WhatsApp (Meta)",
          reconnectButton: "Reconectar Meta",
          connecting: "Conectando com a Meta…",
          cloudLabel: "Meta Cloud",
          coexistenceHint:
            "Coexistência: após o cadastro, abra o app WhatsApp Business no celular para concluir a sincronização.",
          signupTitle: "Cadastro Incorporado WhatsApp",
          signupInstructions:
            "Faça login na Meta e selecione ou cadastre o número do WhatsApp Business. O token será salvo nesta conexão.",
          promptLinked: "Prompt da conexão atualizado",
          sdrPrompt: "Prompt atendimento",
          sdrPromptFallback: "Fallback global",
          promptsHint:
            "Upsell e pós-venda: atribua em Configurações → Prompts da IA.",
        },
        bridge: {
          title: "Android Bridge (USB)",
          hybridTitle: "Modo híbrido (Web + USB)",
          usbTitle: "Modo USB — sem WhatsApp Web",
          agentOnline: "Agente local online",
          agentOffline: "Agente local offline",
          instructions:
            "Receba mensagens pelo WhatsApp Web (QR Code). Envie texto pelo USB quando o agente estiver online; mídia sempre pelo Web. Sem MacroDroid.",
          hybridInstructions:
            "1) Abra o QR Code e escaneie no celular. 2) No mesmo modal, selecione o aparelho USB que leu o QR e clique em Vincular aparelho.",
          usbInstructions:
            "Sem QR Code. 1) Inicie INICIAR-FRANCA.bat no PC com o celular via USB. 2) Crie a conexão aqui. 3) Clique em Vincular aparelho. 4) Informe o WhatsApp ID no painel do PC. Mensagens entram pelas notificações do celular.",
          pairSectionTitle: "Vincular celular USB",
          pairHint:
            "Escolha o aparelho conectado via USB que escaneou este QR Code nesta instância.",
          selectDevice: "Celular USB",
          noDevices: "Nenhum celular detectado no agente local.",
          agentRequired:
            "Inicie o agente Bridge no PC com o celular conectado via USB.",
          alreadyPaired: "Aparelho vinculado:",
          keepAwakeTitle: "Manter tela ligada",
          keepAwakeMinutes: "Min",
          keepAwakeSave: "Salvar",
          keepAwakeSaved: "Timer de tela salvo.",
          keepAwakeInvalid: "Informe minutos válidos (0 desliga).",
          keepAwakeActive: "Ação a cada {{minutes}} min no aparelho USB.",
          keepAwakeOff: "Desligado (0 = sem ação).",
          escrcpyHint:
            "Espelhar tela: scrcpy -s SERIAL_DO_APARELHO (ou Escrcpy no PC).",
          pairDevice: "Vincular aparelho",
          paired: "Aparelho vinculado com sucesso!",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar WhatsApp",
          edit: "Editar WhatsApp",
        },
        form: {
          name: "Nome",
          default: "Padrão",
          farewellMessage: "Mensagem de despedida",
          counterPhone: "Número do contador",
          autoDisableCounter: "Desativação automática",
          connectionMode: "Modo de conexão",
          connectionModeHybrid: "Híbrido (Web recebe + USB envia texto)",
          connectionModeWeb: "Somente Web (iPhone / sem USB)",
          connectionModeHybridHint:
            "Recebe mensagens pela Web e envia texto pelo celular Android via USB.",
          connectionModeWebHint:
            "Recebe e envia tudo pela sessão Web. Use para iPhone ou quando USB não funciona.",
          connectionModeUsb: "Somente USB (depuração Android)",
          connectionModeUsbHint:
            "Não use QR Code nem WhatsApp Web. Conecte o celular via USB, vincule o aparelho e use o agente Franca Bridge no PC.",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "WhatsApp salvo com sucesso.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
        scanDone: "QR Code lido! Agora vincule o celular USB.",
        webActive: "Sessão Web ativa. Vincule o aparelho USB abaixo.",
        waiting: "Aguardando QR Code...",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os tickets relacionados serão perdidos.",
          importMessage: "Deseja importas todos os contatos do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
        },
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Ações",
        },
        paidBadge: "(PAGO)",
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
      },
      quickAnswersModal: {
        title: {
          add: "Adicionar Resposta Rápida",
          edit: "Editar Resposta Rápida",
        },
        form: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
          selectMedia: "Selecionar áudio ou vídeo pronto",
          selectAudio: "Selecionar áudio pronto",
          selectedAudio: "Áudio selecionado",
          audio: "Áudio",
          video: "Vídeo",
          messageOptionalWithAudio: "Opcional quando houver mídia anexada",
          messageOrAudioRequired: "Informe um texto ou selecione um áudio/vídeo",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Resposta Rápida salva com sucesso.",
      },
      queueModal: {
        title: {
          add: "Adicionar fila",
          edit: "Editar fila",
        },
        form: {
          name: "Nome",
          color: "Cor",
          greetingMessage: "Mensagem de saudação",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          profile: "Perfil",
          whatsapp: "Conexão Padrão",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Usuário salvo com sucesso.",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      ticketsWhatsappSelect: {
        placeholder: "Números",
      },
      tickets: {
        toasts: {
          deleted: "O ticket que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar tickets e mensagens",
        },
        buttons: {
          showAll: "Todos",
        },
        responseWindow: {
          open: "Janela: {{time}}",
          openTip:
            "Janela de 24h da Meta: conta a partir da última mensagem do cliente. Respostas livres enquanto estiver aberta.",
          closed: "Janela: encerrada",
          closedTip:
            "Janela de 24h encerrada. Para falar de novo, use um template aprovado ou aguarde o cliente enviar mensagem.",
          noCustomerMessage: "Janela: aguardando cliente",
          noCustomerMessageTip:
            "Ainda não há mensagem do cliente neste ticket. A janela de 24h inicia quando ele enviar a primeira mensagem.",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para fila",
        fieldConnectionLabel: "Transferir para conexão",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldConnectionPlaceholder: "Selecione uma conexão",
        noOptions: "Nenhum usuário encontrado com esse nome",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum ticket encontrado com esse status ou termo pesquisado",
        connectionTitle: "Conexão que está sendo utilizada atualmente.",
        buttons: {
          accept: "Aceitar",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          waba: "WABA",
          meta: "META",
          tickets: "Tickets",
          contacts: "Contatos",
          quickAnswers: "Respostas Rápidas",
          chatFlows: "Fluxos",
          pixel: "Pixel",
          campanhas: "Tracking",
          webhook: "Webhook",
          counterNumbers: "Números",
          leadMessages: "Registro de Mensagens",
          queues: "Filas",
          administration: "Administração",
          users: "Usuários",
          settings: "Configurações",
          proxy: "Proxy",
        },
        appBar: {
          autoAttend: "Atendimento automático com IA",
          autoAttendSelectNumbers: "Escolha os números com IA automática",
          autoAttendConfirm: "Ativar",
          autoAttendCancel: "Cancelar",
          disableAllAi: "Desligar IA em todos os tickets",
          disableAllAiConfirm:
            "Desligar a IA em TODOS os tickets agora? (atendimento, upsell e pós-venda)",
          disableAllAiDone: "IA desligada em {{count}} ticket(s).",
          translation: "Tradução em tempo real (desligar para não gastar API)",
          translationNeedsKey:
            "Configure a chave Google Translation em Configurações para activar",
          translationEnabled: "Tradução automática",
          agentLanguage: "Idioma principal (painel)",
          outputLanguage: "Idioma de saída (mensagens enviadas)",
          translationPrivacyNote:
            "Principal: LibreTranslate na VPS. Google fica em standby se o Libre falhar.",
          translationLibreUrl: "URL LibreTranslate",
          translationLibreHelp: "Ex.: http://127.0.0.1:5000 (só localhost na VPS)",
          translationSaveLibre: "Guardar URL Libre",
          translationLibreSaved: "URL LibreTranslate guardada",
          translationLibreConfigured: "LibreTranslate configurado (principal)",
          translationLibreMissing: "Sem URL Libre — use Google standby ou configure",
          translationApiKey: "Google standby (API key)",
          translationApiKeyHelp:
            "Usado só se o LibreTranslate falhar. Pode deixar vazio se o Libre estiver estável.",
          translationSaveApiKey: "Guardar Google standby",
          translationKeySaved: "Chave Google guardada",
          translationKeyConfigured: "Google standby configurado",
          translationUsesGemini: "A usar chave Gemini das configurações de IA",
          translationKeyMissing: "Sem Google standby",
          translationApiKeyEmpty: "Cole a chave antes de guardar",
          translationApiKeyReplace: "Cole nova chave para substituir",
          user: {
            profile: "Perfil",
            logout: "Sair",
          },
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
      },
      queues: {
        title: "Filas",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar fila",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os tickets dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queueSelect: {
        inputLabel: "Filas",
      },
      quickAnswers: {
        title: "Respostas Rápidas",
        table: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
          audio: "Mídia",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Resposta Rápida",
        },
        toasts: {
          deleted: "Resposta Rápida excluída com sucesso.",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle:
            "Você tem certeza que quer excluir esta Resposta Rápida: ",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
      },
      chatFlows: {
        title: "Fluxos",
        hint:
          "Editor visual estilo chatbot builder: arraste nós, conecte arestas e ative o fluxo. Roda em tickets sem atendente (Meta Cloud).",
        noFlows: "Nenhum fluxo cadastrado.",
        table: {
          name: "Nome",
          keyword: "Gatilho",
          triggers: "Gatilhos",
          manualOnly: "Só manual",
          active: "Ativo",
          actions: "Ações",
        },
        buttons: {
          add: "Novo fluxo",
          save: "Salvar",
          cancel: "Cancelar",
          openEditor: "Abrir editor",
        },
        form: {
          name: "Nome do fluxo",
          message: "Mensagem de texto",
          active: "Ativo",
          keyword: "Palavra-chave",
          graph: "Grafo JSON (nodes/edges)",
        },
        modal: {
          create: "Criar fluxo",
          edit: "Editar fluxo",
        },
        toasts: {
          created: "Fluxo criado.",
          updated: "Fluxo atualizado.",
          deleted: "Fluxo excluído.",
        },
        nodes: {
          start: "Início",
          message: "Mensagem",
          audio: "Áudio",
          video: "Vídeo",
          button: "Botões",
          list: "Lista",
          input: "Entrada",
          wait_reply: "Esperar resposta",
          condition: "Condição",
          delay: "Delay",
          api_call: "Chamada API",
          ai_reply: "Resposta IA",
          loop: "Loop",
          subflow: "Subfluxo",
          end: "Fim",
        },
        editor: {
          title: "Editor de fluxo",
          tabFlow: "Fluxo",
          tabTriggers: "Gatilhos",
          palette: "Biblioteca",
          paletteHint: "Arraste nós para o canvas (Mensagem, Áudio, Vídeo…)",
          config: "Configuração",
          selectNode: "Selecione um nó para editar.",
          label: "Rótulo",
          text: "Texto",
          prompt: "Pergunta",
          waitPrompt: "Mensagem opcional (antes de esperar)",
          waitPromptHint: "Deixe vazio para só pausar até a próxima mensagem do cliente.",
          variableName: "Salvar em variável",
          mediaType: "Tipo de conteúdo",
          mediaText: "Texto",
          mediaImage: "Imagem",
          mediaVideo: "Vídeo",
          mediaAudio: "Áudio",
          caption: "Legenda (opcional)",
          mediaUrl: "URL da mídia",
          mediaUrlHint: "URL pública https://… ou use o upload abaixo",
          audioHint:
            "Grave no navegador ou envie ogg/mp3/m4a/webm. No WhatsApp o áudio é enviado como nota de voz.",
          videoHint:
            "Preferência: MP4 (H.264). Tamanho máximo sugerido: 64 MB.",
          imageHint: "JPG, PNG ou WEBP.",
          asVoiceNote: "Enviar como nota de voz",
          fileTooLarge: "Arquivo muito grande (máx. {{max}} MB).",
          upload: "Enviar arquivo",
          record: "Gravar",
          stopRecord: "Parar",
          clearMedia: "Remover mídia",
          buttons: "Botões",
          buttonLabel: "Texto",
          addButton: "Adicionar botão",
          buttonMode: "Tipo de botão",
          buttonModeReply: "Resposta (reply)",
          buttonModeCta: "Ação / CTA (link)",
          buttonModeReplyHint:
            "Até 3 botões de resposta. O fluxo pausa e segue pela aresta do botão clicado.",
          buttonModeCtaHint:
            "1 botão de link (Meta CTA URL). Após enviar, o fluxo avança automaticamente (o clique abre o navegador e não volta ao webhook).",
          ctaSection: "Botão de ação (CTA URL)",
          ctaContinueHint:
            "Conecte a saída padrão ao próximo nó. Para esperar uma mensagem após o CTA, use o nó “Esperar resposta”.",
          ctaCatalog: "CTA salvo (catálogo)",
          ctaCatalogManual: "Preencher manualmente",
          ctaCatalogHint: "Opcional: escolhe um CTA salvo e preenche os campos abaixo.",
          ctaBody: "Texto da mensagem",
          ctaDisplayText: "Texto do botão",
          ctaUrl: "URL (https)",
          ctaUrlHint: "Obrigatório: URL começando com https://",
          ctaHeader: "Cabeçalho (opcional)",
          ctaFooter: "Rodapé (opcional)",
          listButton: "Texto do botão da lista",
          addRow: "Adicionar item",
          leftOperand: "Operando esquerdo",
          operator: "Operador",
          rightOperand: "Operando direito",
          seconds: "Segundos",
          handoff: "Encerrar e liberar para humano/IA",
          deleteNode: "Excluir nó",
          nameRequired: "Informe um nome com pelo menos 2 caracteres.",
        },
        triggers: {
          title: "Gatilhos do funil",
          hint:
            "Define quando este fluxo inicia em tickets abertos/sem atendente, se não houver sessão ativa.",
          mode: "Modo de início",
          anyMessage: "Qualquer mensagem (any_message)",
          contains: "Mensagem contém (keyword)",
          exact: "Mensagem exata (exact)",
          modeHelp:
            "Correspondência específica tem prioridade sobre “qualquer mensagem”.",
          phrases: "Frases gatilho",
          phrasePlaceholder: "Ex.: oi, orçamento, cardápio",
          addPhrase: "Adicionar",
          phrasesRequired: "Informe ao menos uma frase gatilho.",
          whatsapp: "Conexão WhatsApp",
          anyWhatsapp: "Todas as conexões",
          whatsappHelp: "Opcional: limitar o funil a uma conexão.",
          enabled: "Gatilhos automáticos",
          enabledHelp:
            "Desligado: o fluxo só inicia quando o agente clica nele no ticket. Ligado: também dispara pelas regras abaixo (any_message, keyword ou exact).",
          oncePerChat: "Disparar só 1 vez por chat",
          oncePerChatHelp:
            "Ligado: o gatilho automático (any_message, keyword ou exact) não reinicia o fluxo neste ticket depois da primeira execução. Desligado: volta a disparar em cada mensagem quando não há sessão ativa. Início manual pelo agente ignora esta chave.",
          priorityNote:
            "Prioridade: match específico (exact/keyword) antes de any_message; entre vários any, vence o de menor id (conexão específica primeiro).",
        },
      },
      users: {
        title: "Usuários",
        table: {
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          whatsapp: "Conexão Padrão",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          aiAssistant: {
            title: "Assistente IA",
            privacyNote:
              "As conversas são enviadas ao provedor de IA configurado (Gemini, Anthropic ou Qwen). Configure as chaves abaixo.",
            provider: "Provedor ativo",
            geminiSection: "Google Gemini",
            anthropicSection: "Anthropic (Claude Sonnet)",
            qwenSection: "QwenCloud (Qwen 3.7 Plus)",
            model: "Modelo Gemini",
            anthropicModel: "Modelo Claude",
            qwenModel: "Modelo Qwen",
            apiKey: "Chave API Gemini",
            anthropicApiKey: "Chave API Anthropic",
            qwenApiKey: "Chave API Qwen / DashScope",
            saveApiKey: "Salvar chave Gemini",
            saveAnthropicApiKey: "Salvar chave Anthropic",
            saveQwenApiKey: "Salvar chave Qwen",
            postSalePromptTitle: "Upsell / pós-pagamento (fallback global)",
            postSalePromptHelp:
              "Usado após o 1º pagamento (automação de 30 min + botão IA) se a conexão não tiver prompt de upsell vinculado. Não confundir com pós-venda (suporte).",
            prompt: "Prompt upsell / pós-pagamento",
            promptHelp:
              "Placeholders: {nome}, {telefone}, {valor_venda}, {utm_campaign}",
            savePrompt: "Salvar prompt upsell / pós-pagamento",
            atendimentoPromptTitle: "Atendimento (fallback global)",
            atendimentoPromptHelp:
              "Usado só se a conexão não tiver prompt de atendimento vinculado na secção acima.",
            atendimentoPrompt: "Prompt atendimento (fallback)",
            saveAtendimentoPrompt: "Salvar prompt atendimento",
            aftercarePromptTitle: "Pós-venda / suporte (fallback global)",
            aftercarePromptHelp:
              "Usado após o 2º pagamento se a conexão não tiver prompt de pós-venda vinculado. Acalmar, apoiar, tratar reclamações — não é upsell.",
            aftercarePrompt: "Prompt pós-venda (suporte)",
            saveAftercarePrompt: "Salvar prompt pós-venda (suporte)",
            autoAttendNewContactsOnly: "IA automática só para contatos novos",
            autoAttendNewContactsOnlyHelp:
              "Quando activo, o atendimento automático com IA só inicia para contactos que nunca receberam resposta humana. Quem já foi atendido por um agente fica à espera de atendimento humano.",
            autoAttendNewContactsOnlyOptions: {
              enabled: "Activado",
              disabled: "Desactivado",
            },
            maxReplies: "Máx. respostas por hora (por ticket)",
            historyMessages: "Mensagens de histórico no contexto (recomendado: 40+)",
            replyDelayMin: "Atraso mínimo (segundos)",
            replyDelayMax: "Atraso máximo (segundos)",
            replyDelayHelp:
              "A IA espera um tempo aleatório entre mínimo e máximo antes de responder. Se máximo = 0 ou igual ao mínimo, usa o mínimo fixo.",
          },
          aiPromptsSection: {
            title: "Prompts da IA",
            help:
              "1) Crie prompts na biblioteca · 2) Atribua por conexão (atendimento, upsell, pós-venda) · 3) Fallbacks globais só entram se a conexão não tiver prompt.",
          },
          aiPrompts: {
            title: "1. Biblioteca de prompts",
            help:
              "Crie e edite prompts salvos. Escolha o modo (atendimento, upsell ou pós-venda) e depois atribua na secção seguinte.",
            name: "Nome do prompt",
            mode: "Modo",
            modeHelp:
              "Define para que fluxo o prompt serve: atendimento, upsell (1º pagamento) ou pós-venda (2º pagamento).",
            modes: {
              atendimento: "Atendimento",
              postsale: "Upsell / pós-pagamento",
              aftercare: "Pós-venda (suporte)",
            },
            prompt: "Texto do prompt",
            active: "Ativo",
            connections: "Conexões vinculadas",
            actions: "Ações",
            add: "Adicionar prompt",
            save: "Salvar alterações",
            cancelEdit: "Cancelar edição",
            created: "Prompt criado",
            updated: "Prompt atualizado",
            deleted: "Prompt removido",
            confirmDelete:
              "Remover este prompt? As conexões vinculadas voltam ao fallback global.",
            required: "Preencha nome e texto do prompt",
            empty: "Nenhum prompt salvo ainda",
            yes: "Sim",
            no: "Não",
          },
          aiPromptAssign: {
            title: "2. Atribuição por conexão",
            help:
              "Para cada conexão WhatsApp, escolha o prompt de atendimento, upsell e pós-venda. Vazio = usa o fallback global.",
            connection: "Conexão",
            useGlobal: "Fallback global",
            saved: "Prompt da conexão atualizado",
            empty: "Nenhuma conexão WhatsApp encontrada",
          },
          aiFallbacks: {
            title: "3. Fallbacks globais",
            help:
              "Usados apenas quando a conexão não tem prompt atribuído para aquele modo. Instalações antigas continuam a funcionar só com estes textos.",
          },
          ctaButtons: {
            sectionTitle: "Botões",
            sectionHelp:
              "1) Crie botões CTA na biblioteca · 2) Atrele quais botões cada conexão WhatsApp pode usar. Sem vínculo = todos os botões (fallback).",
            libraryTitle: "1. Biblioteca de botões",
            libraryHelp:
              "Crie e edite botões com link (CTA). A IA usa [[CTA_BUTTON:Nome]] e o atendente envia pelo chat.",
            assignTitle: "2. Atribuição por conexão",
            assignHelp:
              "Para cada número/conexão, marque os botões permitidos. Lista vazia = usa todos os botões globais.",
            linkedButtons: "Botões",
            useAllButtons: "Todos os botões (fallback)",
            assignSaved: "Botões da conexão atualizados",
          },
          translation: {
            title: "Tradução em tempo real",
            privacyNote:
              "Usa Google Cloud Translation API. Active a API no Google Cloud Console (separada do Gemini).",
            enabled: "Tradução activa",
            agentLanguage: "Idioma do agente (o que lê e escreve no painel)",
            apiKey: "Chave API Google Translation",
            apiKeyHelp:
              "Pode usar a mesma conta Google do Gemini, mas precisa activar Cloud Translation API.",
            saveApiKey: "Salvar chave de tradução",
            options: {
              enabled: "Activada",
              disabled: "Desactivada",
            },
          },
        },
      },
      messagesList: {
        aiBadge: "IA",
        translationLabel: "Tradução",
        sentTranslationLabel: "Enviado",
        translateButton: "Traduzir",
        translating: "Traduzindo...",
        ctaUrl: {
          open: "Abrir link",
        },
        header: {
          assignedTo: "Atribuído à:",
          aiActive: "IA ativa",
          aiModeSdr: "Atendimento",
          aiModePostSale: "Upsell / Pós-pagamento",
          aiModePostSaleShort: "Upsell",
          aiModeAftercare: "Pós-venda (suporte)",
          aiModeAftercareShort: "Pós-venda",
          aiDisable: "Desligar IA",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
            pixel: "Pixel",
            ai: "IA",
            aiOn: "IA ligada",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Digite uma mensagem ou tecle ''/'' para utilizar as respostas rápidas cadastrada",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
        quickAnswerAudio: "Áudio pronto",
        quickAnswerVideo: "Vídeo pronto",
        translationPreview: "Será enviado em {{language}}: {{text}}",
        translationAgentPreview: "Tradução para {{language}}: {{text}}",
        chatFlows: {
          label: "Fluxos de chat",
          starting: "Iniciando…",
          started: "Fluxo \"{{name}}\" iniciado.",
          confirmTitle: "Disparar fluxo",
          confirmMessage:
            "Deseja iniciar o fluxo \"{{name}}\" neste atendimento? Uma sessão anterior em andamento será substituída.",
          statusRunning: "Em andamento",
          statusWaiting: "Aguardando resposta",
          statusCompleted: "Fluxo concluído",
          statusHandedOff: "Encaminhado ao atendente",
          statusError: "Erro no fluxo",
          statusCancelled: "Fluxo cancelado",
        },
        ctaUrl: {
          title: "Botão com link (CTA)",
          listTitle: "Botões com link salvos",
          createTitle: "Criar botão com link",
          editTitle: "Editar botão com link",
          name: "Nome (opcional)",
          header: "Cabeçalho (opcional)",
          body: "Texto da mensagem",
          displayText: "Texto do botão",
          url: "URL (https)",
          footer: "Rodapé (opcional)",
          send: "Enviar",
          save: "Salvar",
          saveAndSend: "Salvar e enviar",
          cancel: "Cancelar",
          createNew: "Criar novo botão",
          edit: "Editar",
          delete: "Excluir",
          emptyList: "Nenhum botão salvo ainda. Crie o primeiro.",
          clickToSend: "Clique para enviar",
          sending: "Enviando...",
          success: "Botão com link enviado",
          saved: "Botão salvo",
          updated: "Botão atualizado",
          deleted: "Botão excluído",
          deleteConfirm: "Excluir o botão \"{{name}}\"?",
          errors: {
            bodyRequired: "Informe o texto da mensagem",
            displayTextRequired: "Informe o texto do botão",
            invalidUrl: "Informe uma URL válida começando com https://",
          },
        },
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
        },
        customerLanguage: "Idioma do cliente",
        customerLanguageAuto: "Detectar automaticamente",
        pixelCreative: "Anúncio",
        pixelAdId: "AD ID",
        extraInfo: "Outras informações",
      },
      ticketOptionsMenu: {
        delete: "Deletar",
        transfer: "Transferir",
        confirmationModal: {
          title: "Deletar o ticket do contato",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      metaOnboarding: {
        introTitle: "Operações Meta / Cloud API",
        introBody:
          "Use Templates e Disparo para gestão real via Graph API. As dicas de App Review abaixo são opcionais — badges não significam Advanced Access da Meta.",
        proofProgress: "Provas manuais marcadas: {{done}}/{{total}}",
        howToRecord: "Como gravar para App Review",
        markDone: "Marquei esta prova / passo como concluído",
        privacyPolicyUrl: "URL da Política de Privacidade",
        termsUrl: "URL dos Termos de Uso",
        policyHelper:
          "Pública no Oficial: https://oficial.simpatxia.online/politica-de-privacidade — use a mesma no Meta App Dashboard → Settings → Basic.",
        termsHelper:
          "Pública no Oficial: https://oficial.simpatxia.online/termos-de-servico — configure também no App Dashboard se pedido.",
        savePolicyUrls: "Salvar URLs nas Configurações",
        openPrivacy: "Abrir privacidade",
        openTerms: "Abrir termos",
        status: {
          available: "Disponível no sistema",
          configure: "Configurar",
          external: "Ação externa (Meta)",
          manual: "Manual App Review",
        },
        sections: {
          messaging: "whatsapp_business_messaging",
          management: "whatsapp_business_management",
          prerequisites: "Pré-requisitos",
        },
        links: {
          tickets: "Conversas / Tickets",
          inbox: "Inbox",
          webhook: "Webhook (painel)",
          waba: "Painel WABA",
          wabaWebhooks: "WABA → Webhooks",
          wabaTemplates: "WABA → Templates",
          wabaSync: "WABA → Sincronizar",
          embeddedSignup: "Embedded Signup",
          connections: "Conexões",
          settings: "Configurações",
          metaTemplates: "Templates no Business Manager",
          coexistenceDocs: "Docs Meta: Coexistência",
          metaDevelopers: "Meta for Developers",
          metaPrivacy: "Requisitos de privacidade",
          metaAppDashboard: "App Dashboard Meta",
          appReviewDocs: "Docs App Review",
        },
        items: {
          msgSend: {
            title: "Enviar mensagem ao cliente",
            desc:
              "Painel Conversas (/tickets) envia texto/mídia via Meta Cloud API.",
            tip:
              "Grave: abrir ticket → digitar mensagem → enviar → mensagem aparece com check. Mostre número oficial Meta Cloud.",
          },
          msgReceive: {
            title: "Receber mensagens no Inbox",
            desc:
              "Webhook Meta ativo; mensagens entram em Tickets em tempo real.",
            tip:
              "Grave: cliente envia no WhatsApp → ticket atualiza no Inbox. Mostre também WABA → Webhooks ou /webhook.",
          },
          msgAck: {
            title: "Status de entrega/leitura (ACK)",
            desc:
              "Webhooks de status atualizam ticks (enviado/entregue/lido) na lista de mensagens.",
            tip:
              "Envie uma mensagem e mostre evolução dos ícones ACK (relógio → 1 check → 2 checks → azul).",
          },
          msgProof: {
            title: "Prova de uso (messaging) para App Review",
            desc:
              "Vídeo + descrição do fluxo funcional de envio/recebimento nesta permissão.",
            tip:
              "Um vídeo contínuo: Conexões Meta → Tickets → enviar → receber → ACK. Descreva o caso de uso no formulário Meta.",
          },
          mgmtConnect: {
            title: "Conectar WABA e número oficial",
            desc:
              "Embedded Signup em /waba-signup e gestão em Conexões / WABA.",
            tip:
              "Grave o Cadastro Incorporado até o número aparecer em Conexões com provider Meta Cloud.",
          },
          mgmtTemplates: {
            title: "Criar/editar templates",
            desc:
              "Criar, listar, excluir e disparar templates no hub META e no painel WABA via Graph API.",
            tip:
              "Grave: META → Templates → Novo template → status PENDING; depois Disparo para número de teste. Edição de aprovados = duplicar/excluir (limitação Meta).",
          },
          mgmtSync: {
            title: "Sincronizar templates e conta WABA",
            desc: "Botão «Sincronizar admin» e abas de overview no /waba.",
            tip:
              "Grave: WABA → Sincronizar admin → números/templates/webhooks atualizados.",
          },
          mgmtWebhook: {
            title: "Assinatura de webhook e evento de teste",
            desc:
              "Reassinatura subscribed_apps no WABA + endpoint /webhook no painel.",
            tip:
              "Mostre URL do webhook, reassinatura e um evento real (mensagem ou status) chegando.",
          },
          mgmtProof: {
            title: "Prova de uso (management) para App Review",
            desc:
              "Vídeo de gestão: conectar, sync, templates/webhooks conforme o uso real.",
            tip:
              "Vídeo separado da permissão messaging: Embedded Signup → WABA sync → templates/webhooks.",
          },
          mgmtCoexistence: {
            title: "Coexistência com WhatsApp Business app",
            desc:
              "Flag coexistence no Embedded Signup; ativação final é recurso da conta Meta + app no celular.",
            tip:
              "Documente: featureType whatsapp_business_app_onboarding + abrir WhatsApp Business no celular após signup. Não finja Advanced Access — é configuração Meta/conta.",
          },
          preDevAccount: {
            title: "Conta Meta Developer ativa",
            desc: "App criado em developers.facebook.com com produtos WhatsApp.",
            tip: "Mostre o App Dashboard (sem expor secrets) e produtos WhatsApp adicionados.",
          },
          prePrivacy: {
            title: "Política de privacidade e termos públicos",
            desc:
              "URLs públicas no App Dashboard; opcionalmente salvas aqui (privacyPolicyUrl / termsUrl).",
            tip:
              "Grave a página pública de privacidade e o campo no Meta App Settings → Basic.",
          },
          preBusiness: {
            title: "Info do negócio / casos de uso alinhados",
            desc:
              "Business Verification e descrição de uso consistentes com o produto.",
            tip:
              "No App Review, descreva atendimento omnichannel WhatsApp oficial — alinhado ao Whaticket.",
          },
          preVideos: {
            title: "Vídeo + descrição por permissão",
            desc:
              "Meta exige screencast e texto separados para messaging e management.",
            tip:
              "Não reutilize o mesmo vídeo nas duas permissões. Marque as checkboxes após gravar cada um.",
          },
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_WAPP_DISPLAY_NAME:
          "A Meta bloqueou o envio: o nome de exibição do número ainda não foi aprovado no WhatsApp Manager.",
        ERR_WAPP_PAYMENT:
          "A Meta bloqueou o envio: há um erro no método de pagamento da conta WhatsApp Business.",
        ERR_WAPP_TOKEN:
          "Falha de autenticação com a Meta. Atualize o token da conexão WhatsApp.",
        ERR_WAPP_UNDELIVERABLE:
          "A Meta não conseguiu entregar a mensagem neste número.",
        ERR_CTA_URL_META_ONLY:
          "Botões com link (CTA) estão disponíveis apenas na API oficial da Meta.",
        ERR_CTA_URL_BODY_REQUIRED: "Informe o texto da mensagem do botão CTA.",
        ERR_CTA_URL_BODY_TOO_LONG:
          "Texto da mensagem CTA excede 1024 caracteres.",
        ERR_CTA_URL_DISPLAY_TEXT_REQUIRED: "Informe o texto do botão CTA.",
        ERR_CTA_URL_DISPLAY_TEXT_TOO_LONG:
          "Texto do botão CTA excede 20 caracteres.",
        ERR_CTA_URL_INVALID_URL:
          "URL do botão CTA inválida. Use um endereço https://.",
        ERR_CTA_URL_HEADER_TOO_LONG:
          "Cabeçalho do CTA excede 60 caracteres.",
        ERR_CTA_URL_FOOTER_TOO_LONG:
          "Rodapé do CTA excede 60 caracteres.",
        ERR_TRANSLATION_FAILED:
          "Não foi possível traduzir a mensagem. Verifique a chave e a Cloud Translation API no Google Cloud.",
        ERR_TRANSLATION_API_BLOCKED:
          "A Cloud Translation API está bloqueada. Active em console.cloud.google.com/apis/library/translate.googleapis.com e verifique restrições da chave.",
        ERR_TRANSLATION_INVALID_KEY:
          "Chave Google Translation inválida. Gere uma nova chave no Google Cloud Console.",
        ERR_TRANSLATION_KEY_TEST_FAILED:
          "Não foi possível validar a chave Google Translation. Tente novamente.",
        ERR_TRANSLATION_API_KEY_EMPTY: "Informe a chave Google Translation.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_PIXEL_INVALID_VALUE: "Informe um valor de venda válido.",
        ERR_PIXEL_LEAD_NOT_FOUND:
          "Lead do pixel não encontrado. Se for Tracking por mensagem, confirme que o padrão casou (linha verde) e tente de novo.",
        ERR_PIXEL_ALREADY_CONVERTED: "Esta conversão já foi enviada ao pixel.",
        ERR_PIXEL_PHONE_NOT_FOUND: "Telefone do contato não encontrado.",
        ERR_PIXEL_SEND_FAILED: "Erro ao enviar conversão para o pixel.",
        ERR_PIXEL_MESSAGE_REQUIRED: "Informe a mensagem para buscar o lead.",
        ERR_PIXEL_DATE_REQUIRED: "Informe a data do clique.",
        ERR_PIXEL_LEAD_ID_REQUIRED: "Lead inválido para envio.",
        ERR_PIXEL_LOOKUP_FAILED: "Erro ao buscar lead no pixel.",
        ERR_COUNTER_NUMBERS_LIST: "Erro ao listar números do contador.",
        ERR_COUNTER_NUMBER_ADD: "Erro ao adicionar número.",
        ERR_COUNTER_NUMBER_TOGGLE: "Erro ao alterar status do número.",
        ERR_COUNTER_NUMBER_UPDATE: "Erro ao atualizar número.",
        ERR_COUNTER_NUMBER_DELETE: "Erro ao remover número.",
        ERR_LEAD_MESSAGES_LIST: "Erro ao listar mensagens recentes.",
        ERR_NO_CHAT_FLOW_FOUND: "Fluxo de chat não encontrado.",
        ERR_CHAT_FLOW_NOT_FOUND: "Fluxo de chat não encontrado.",
        ERR_CHAT_FLOW_INACTIVE: "Este fluxo de chat está inativo.",
        ERR_CHAT_FLOW_WHATSAPP_MISMATCH:
          "Este fluxo não pertence à conexão WhatsApp deste atendimento.",
        ERR_CHAT_FLOW_NO_START:
          "Este fluxo não tem um nó inicial válido. Abra o editor e salve o fluxo novamente.",
        ERR_CHAT_FLOW_START_FAILED:
          "Não foi possível iniciar o fluxo neste atendimento. Tente novamente.",
      },
      leadMessages: {
        title: "Registro de Mensagens",
        section: {
          title: "Últimas Mensagens Recebidas",
          subtitle:
            "Leads recentes — mensagem, número WPP destino, campanha e estado",
        },
        stats: {
          total: "Total de leads",
          today: "Leads hoje",
          converted: "Convertidos",
        },
        table: {
          date: "Data/Hora",
          message: "Mensagem",
          destination: "Nº WPP Destino",
          campaign: "Campanha",
          status: "Estado",
        },
        status: {
          pending: "Pendente",
          converted: "Vendido · €{{value}}",
        },
        empty: "Nenhuma mensagem recebida ainda.",
      },
      proxy: {
        title: "Proxy WhatsApp",
        formatHint:
          "Cole no formato host:porta:usuario:senha — tipo padrão HTTP (opcional: socks5 ou socks4 no final)",
        status: {
          enabled: "Proxy ativo",
          disabled: "Proxy desativado",
        },
        source: {
          settings: "Origem: painel",
          env: "Origem: .env",
          none: "Nenhum proxy configurado",
        },
        fields: {
          enabled: "Usar proxy no WhatsApp",
          rawLine: "Proxy completo",
          parsedTitle: "Campos reconhecidos automaticamente",
          host: "Host",
          port: "Porta",
          username: "Usuário",
          password: "Senha",
          passwordKeep: "Deixe em branco para manter a senha atual",
          type: "Tipo",
        },
        buttons: {
          save: "Salvar proxy",
          check: "Testar proxy",
          reload: "Recarregar",
        },
        check: {
          ok: "Proxy funcionando",
          fail: "Falha no teste do proxy",
          latency: "Latência: {{ms}} ms",
          ip: "IP externo: {{ip}}",
        },
        toasts: {
          saved: "Proxy salvo com sucesso!",
          checkOk: "Proxy testado com sucesso!",
          checkFail: "Proxy não respondeu",
        },
        note:
          "Após alterar o proxy, desconecte e reconecte a sessão WhatsApp em Conexões para aplicar a mudança.",
      },
      counterNumbers: {
        title: "Números do Contador",
        stats: {
          daily: "Cliques no dia",
          total: "Cliques totais",
          active: "Canais ativos",
        },
        form: {
          addTitle: "Adicionar novo canal",
          name: "Nome / Identificação",
          namePlaceholder: "ex: WPP Principal",
          phone: "Telefone",
          message: "Mensagem padrão (opcional)",
          add: "Adicionar",
          save: "Salvar",
          cancel: "Cancelar",
          phoneRequired: "Informe o telefone.",
        },
        table: {
          active: "Ativo",
          name: "Canal",
          daily: "Cliques (dia)",
          total: "Cliques (total)",
          rotation: "Rotação",
          actions: "Ações",
        },
        rotation: {
          next: "Próximo",
          last: "Último",
          queued: "Em fila",
          inactive: "Inativo",
        },
        edit: {
          title: "Editar canal",
        },
        confirmDelete: {
          title: "Remover número",
          message: "Tem certeza? O número será removido do contador de cliques.",
        },
        toasts: {
          added: "Número adicionado com sucesso!",
          updated: "Número atualizado!",
          deleted: "Número removido!",
        },
      },
      webhookPage: {
        title: "Webhook Stripe",
        endpoint1Title: "Endpoint 1 (Stripe principal)",
        endpoint2Title: "Endpoint 2 (segunda Stripe)",
        urlLabel: "URL do webhook (cole no Stripe Dashboard)",
        copy: "Copiar",
        copied: "URL copiada!",
        copyFail: "Não foi possível copiar.",
        refresh: "Atualizar",
        secretLabel: "Signing secret (whsec_...)",
        secretPlaceholder: "whsec_••••••••",
        secretSave: "Salvar secret",
        secretSaved: "Signing secret salva!",
        secretRequired: "Informe o signing secret.",
        secretInvalid: "O secret deve começar com whsec_.",
        secretHelp:
          "Cole o Signing secret do Stripe Dashboard. Fica salvo no banco (Settings) — sem reiniciar o PM2.",
        secretConfiguredHint:
          "Configurada (••••{{last4}}). Digite um novo valor para substituir.",
        secretOk: "Signing secret configurada",
        secretOkMasked: "Configurada ••••{{last4}}",
        secretMissing: "Signing secret não configurada",
        instructions:
          "No Stripe → Developers → Webhooks → Add endpoint.\nEndpoint 1: cole a URL do endpoint 1 na conta Stripe principal.\nEndpoint 2: cole a URL do endpoint 2 na segunda conta Stripe.\nSelecione os eventos checkout.session.* e payment_intent.*.\nDepois copie o Signing secret (whsec_...) de cada endpoint e salve no campo correspondente (admin).\nNão é necessário secret key (sk_) — o painel só valida a assinatura do webhook.\n\nEventos tratados:",
        logsTitle: "Últimas chamadas Stripe",
        empty: "Nenhum evento recebido ainda.",
        table: {
          createdAt: "Quando",
          eventType: "Evento",
          status: "Status",
          contact: "Contacto",
          ticket: "Ticket",
          pixel: "Pixel",
          error: "Erro",
        },
      },
      campanhasPage: {
        title: "Tracking",
        hint:
          "Cadastre o padrão da mensagem do WhatsApp + Meta IDs/UTMs. Ao enviar um botão Stripe do sistema, as UTMs e o client_reference_id são anexados automaticamente. Após o pagamento (postback Stripe), o valor pago é enviado à Meta como Purchase.",
        empty: "Nenhum tracking cadastrado ainda.",
        buttons: {
          add: "Novo tracking",
          save: "Salvar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nome",
          pattern: "Mensagem",
          mode: "Modo",
          metaIds: "Meta IDs",
          status: "Status",
          actions: "Ações",
        },
        modes: {
          contains: "Contém",
          exact: "Exata",
        },
        status: {
          on: "Ativo",
          off: "Off",
        },
        modal: {
          create: "Novo tracking",
          edit: "Editar tracking",
        },
        form: {
          name: "Nome",
          messagePattern: "Padrão da mensagem",
          messagePatternHelp:
            "Texto que o cliente envia no WhatsApp (ex.: emoji ou frase da campanha).",
          matchMode: "Modo de match",
          enabled: "Ativo",
          campaignId: "campaign_id",
          adsetId: "adset_id",
          adId: "ad_id",
          pixelId: "Pixel ID",
          pixelIdHelp:
            "ID do pixel Meta que receberá as Purchases deste tracking. Só este valor é usado no envio.",
          currency: "Moeda (fallback)",
          currencyHelp:
            "Usada só se o postback Stripe não trouxer moeda. O valor da venda vem sempre do pagamento.",
          stripeLink: "Link Stripe Payment",
          stripeLinkHelp:
            "Não use este campo — os botões Stripe já cadastrados no sistema recebem as UTMs no envio.",
          defaultValue: "Valor padrão",
        },
        confirmation: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser desfeita.",
        },
        toasts: {
          saved: "Tracking salvo.",
          deleted: "Tracking removido.",
          required: "Nome e padrão da mensagem são obrigatórios.",
          pixelRequired: "Informe o Pixel ID do tracking.",
          copied: "Link Stripe copiado.",
          noStripe: "Cadastre o link Stripe neste tracking.",
        },
      },
      pixel: {
        title: "Pixel",
        creative: "Criativo",
        adLabel: "Anúncio",
        adId: "AD ID",
        trackingLabel: "Tracking",
        trackingMatched: "Tracking casado",
        trackingNotMatched: "Sem tracking por mensagem",
        adNotFound: "Anúncio não identificado",
        campaignLabel: "Campanha",
        campaignNotFound: "Campanha não identificada",
        search: "Buscar por mensagem, telefone ou criativo",
        loadMore: "Carregar mais",
        stats: {
          total: "Verificados",
          complete: "Completos",
          incomplete: "Incompletos",
          converted: "Convertidos",
        },
        table: {
          contact: "Contato",
          message: "Mensagem",
          creative: "Criativo",
          phone: "Telefone",
          status: "Status Pixel",
          checkedAt: "Verificado em",
        },
        status: {
          complete: "Completo",
          incomplete: "Incompleto",
          notFound: "Não encontrado",
          convertedShort: "Convertido",
          converted: "Convertido · €{{value}}",
          purchasesSummary: "{{count}} purchase(s) · Total €{{value}}",
        },
        modal: {
          title: "Enviar conversão ao Pixel",
          phone: "Telefone (automático)",
          value: "Valor da venda (€)",
          send: "Enviar ao Pixel",
          sendUpsell: "Enviar upsell",
          cancel: "Cancelar",
          refresh: "Verificar novamente",
          message: "Mensagem rastreada",
          lookupDate: "Data do clique",
          leadDate: "Data do clique",
          lastPurchase: "Último envio",
          invalidValue: "Informe um valor válido.",
          success: "Conversão enviada ao pixel com sucesso!",
          upsellSuccess: "Upsell enviado ao pixel com sucesso!",
          refreshed: "Dados do pixel atualizados.",
        },
        manual: {
          title: "Busca manual",
          date: "Data do clique",
          message: "Mensagem exata",
          messagePlaceholder: "Cole a mensagem que o cliente enviou ao WhatsApp",
          search: "Buscar lead",
          phone: "Telefone do comprador",
          notFound: "Nenhum lead encontrado para esta mensagem e data.",
          clear: "Limpar",
          messageRequired: "Informe a mensagem para buscar.",
          dateRequired: "Informe a data do clique.",
          phoneRequired: "Informe o telefone do comprador.",
        },
      },
    },
  },
};

export { messages };
